import axios from "axios";
var ApiFetcher = /** @class */ (function () {
    function ApiFetcher() {
        this.axiosInstance = axios.create();
        axios.defaults.validateStatus = function (status) {
            return status >= 200 && status < 300;
        };
    }
    ApiFetcher.prototype.get = function (url, config) {
        return this.axiosInstance
            .get(url, config)
            .then(function (res) {
            return res.data;
        });
    };
    ApiFetcher.prototype.post = function (url, data, config) {
        return this.axiosInstance
            .post(url, data, config)
            .then(function (res) {
            return res.data;
        });
    };
    return ApiFetcher;
}());
export { ApiFetcher };
//# sourceMappingURL=index.js.map